import NotificationsFilters from './NotificationsFilters';

export default NotificationsFilters;
